import ReactDOM from "react-dom/client";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import PrivateRouter from "../utils/PrivateRouter";


import  {default as Dashboard}  from "../components/Dashboard";
import  Cash  from "../components/Transactions/Cash";
import  Equity  from "../components/Transactions/Equity";
import  Private from "../components/Transactions/Private";
import  Bonds from "../components/Transactions/Bonds";
import  Options from "../components/Transactions/Options";
import Forms from "../components/Forms/Forms";
import Login from "../components/Auth/Login";
import Logout from "../components/Auth/Logout";
import Documents from "../components/Documents/Documents";
import Reports from "../components/Reports/Reports";
import Vdr from "../components/Vdr/Vdr";

const routes = [
    {
        path: "/",
        exact: true,
        component: <Login/>
    },
    {
      path: "/dashboard",
      exact: true,
      component: <Dashboard/>
    },
    {
        path:"/transaction/cash",
        exact:true,
        component:<Cash />
    },
    {
        path:"/transaction/:type",
        exact:true,
        component:<Equity />
    },
    {
        path:"/transaction/private",
        exact:true,
        component:<Private />
    },
    {
        path:"/transaction/bonds",
        exact:true,
        component:<Bonds />
    },
    {
        path:"/transaction/options",
        exact:true,
        component:<Options />
    },
    {
        path:"/forms",
        exact:true,
        component:<Forms />
    },
    { 
        path:"/logout",
        exact:true,
        component:<Logout />
    },
    { 
        path:"/documents",
        exact:true,
        component:<Documents/>
    },
    { 
        path:"/reports",
        exact:true,
        component:<Reports />
    },
    { 
        path:"/vdr",
        exact:true,
        component:<Vdr />
    },

    
];


function Approuter() {
    return (
            // <BrowserRouter>
                <Routes>
                    {routes.map((route, index) => (
                        <Route
                            key={index}
                            path={route.path}
                            exact={route.exact}
                            element={route.component}
                        />
                    ))}
                </Routes>
            // </BrowserRouter>
    )
}

export default Approuter
